import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.375 11.375h-2.5a.625.625 0 0 0 0 1.25h2.5a.625.625 0 0 0 0-1.25M12 17.625A5.63 5.63 0 0 0 17.625 12 5.63 5.63 0 0 0 12 6.375 5.63 5.63 0 0 0 6.375 12 5.63 5.63 0 0 0 12 17.625m0-10A4.38 4.38 0 0 1 16.375 12 4.38 4.38 0 0 1 12 16.375 4.38 4.38 0 0 1 7.625 12 4.38 4.38 0 0 1 12 7.625M12 5.75c.345 0 .625-.28.625-.625v-2.5a.625.625 0 0 0-1.25 0v2.5c0 .345.28.625.625.625M12.625 21.375v-2.5a.625.625 0 0 0-1.25 0v2.5a.625.625 0 0 0 1.25 0M2.625 12.625h2.5a.625.625 0 0 0 0-1.25h-2.5a.625.625 0 0 0 0 1.25M6.697 7.58a.623.623 0 0 0 .884 0 .624.624 0 0 0 0-.883L5.813 4.929a.624.624 0 1 0-.884.884zM17.303 16.42a.624.624 0 1 0-.884.883l1.768 1.768a.623.623 0 0 0 .884 0 .624.624 0 0 0 0-.884zM16.861 7.764c.16 0 .32-.062.442-.183l1.768-1.768a.624.624 0 1 0-.884-.884l-1.768 1.768a.624.624 0 0 0 .442 1.067M6.697 16.42l-1.768 1.767a.624.624 0 1 0 .884.884l1.768-1.768a.624.624 0 1 0-.884-.884"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M9.188 11.375c.172 0 .312-.14.312-.312 0-.862.701-1.563 1.563-1.563a.313.313 0 0 0 0-.625 2.19 2.19 0 0 0-2.188 2.188c0 .172.14.312.313.312"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }